import { ActionTree } from "vuex";
import { MessageState, Message } from "./model";
import { RootStateType } from "@/store";
import { AxiosResponse } from "axios";
import Qs from "qs";

const actions: ActionTree<MessageState, RootStateType> = {
  findList({ rootGetters, commit }, params) {
    const paramsHash = {
      params: params,
      paramsSerializer: function (params: object) {
        return Qs.stringify(params, { arrayFormat: 'brackets' })
      }
    }

    return rootGetters['hcs/client'].get('/messages', paramsHash)
      .then((response: AxiosResponse) => {
        const messages: Message[] = response.data;
        commit('setMessages', messages)
        return {
          messages,
          page: parseInt(response.headers['x-page'], 10),
          perPage: parseInt(response.headers['x-per-page'], 10),
          total: parseInt(response.headers['x-total'], 10),
        }
      })
  },
  find({ rootGetters, commit }, id) {
    return rootGetters['hcs/client'].get(`/messages/${id}`)
      .then((response: AxiosResponse) => {
        const message: Message = response.data;
        commit('setMessage', message)
        return message
      })
  },
  requestDestroy({ rootGetters, commit }, id) {
    return rootGetters['hcs/client'].post(`/messages/${id}/request_destroy`)
  }
}

export default actions;
